// src/pages/TeacherPanel.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ReactComponent as ikona1} from '../../assets/zaplanowane.svg';
import { ReactComponent as ikona2} from '../../assets/zakonczone.svg';
import { ReactComponent as ikona3} from '../../assets/grupa.svg';
import { ReactComponent as ikona4} from '../../assets/egzaminy.svg';

const api = axios.create({ baseURL: '/api/prowadzacy' });
const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

function fmtDT(v) {
    try {
        return new Intl.DateTimeFormat('pl-PL', { dateStyle: 'medium', timeStyle: 'short' })
            .format(new Date(v));
    } catch { return v; }
}

export default function TeacherPanel() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);
    const [terms, setTerms] = useState([]);

    useEffect(() => {
        api.get('/terms/upcoming?limit=8', { headers: authHeader() })
            .then(r => setTerms(r.data || []))
            .catch(e => setErr(e?.response?.data?.blad || 'Błąd pobierania'))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div style={{ marginTop:80, padding: '0 16px'}}>

            {/* Kafelki */}
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px,1fr))', gap:16, marginBottom:24 }} >
                <Tile title="Nadchodzące terminy" onClick={()=>navigate('/prowadzacy/terminy/zaplanowane')}  iconSvg={ikona1} />
                <Tile title="Zakończone terminy" onClick={()=>navigate('/prowadzacy/terminy/koniec')}  iconSvg={ikona2} />
                <Tile title="Egzaminy" onClick={()=>navigate('/prowadzacy/egzaminy')}  iconSvg={ikona4} />
                <Tile title="Moje grupy" onClick={()=>navigate('/prowadzacy/grupy')}  iconSvg={ikona3} />
            </div>

            <h2 style={{ margin:'8px 0 12px' }}>Nadchodzące terminy</h2>

            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{ color:'crimson' }}>{err}</div>
            ) : terms.length === 0 ? (
                <EmptyState />
            ) : (
                <div style={{ display:'grid', gap:12, maxWidth:'900px' }}>
                    {terms.map(t => <TermCard key={t.term_id} term={t} />)}
                </div>
            )}
        </div>
    );
}


function Tile({ title, onClick, iconSvg: IconSvg, iconSrc }) {
    return (
        <button
            onClick={onClick}
            style={{
                display: 'grid',
                placeItems: 'center',
                gap: 10,
                textAlign: 'center',
                border: '1px solid #e5e7eb',
                borderRadius: 12,
                padding: 16,
                background: 'white',
                cursor: 'pointer',
                boxShadow: '0 1px 2px rgba(0,0,0,.05)',
                transition: 'transform .08s ease, box-shadow .15s ease',
            }}
            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.98)')}
            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
            {/* Ikona nad tytułem: preferuj komponent SVG, fallback do <img src> */}
            {IconSvg ? (
                <IconSvg style={{ width: 70, height: 70, opacity: 0.95, fill:'#b02912' }} aria-hidden />
            ) : iconSrc ? (
                <img src={iconSrc} alt="" style={{ width: 80, height: 80, opacity: 0.95 }} />
            ) : null}

            <div style={{ fontSize: 16, fontWeight: 600, marginTop:10 }}>{title}</div>
        </button>
    );
}

function TermCard({ term }) {
    const navigate = useNavigate();
    const startTs = useMemo(()=>new Date(term.exam_datetime).getTime(), [term.exam_datetime]);
    const now = Date.now();
    const fifteenMin = 15 * 60 * 1000;

    const beforeStart = now < startTs - fifteenMin;
    const label = beforeStart ? 'Szczegóły' : 'Przebieg';
    const target = beforeStart ? `/prowadzacy/termin/${term.term_id}` : `/prowadzacy/termin/${term.term_id}/przebieg`;
    const go = () => navigate(target);
    return (
        <div onClick={go}
            style={{
                border:'1px solid #e5e7eb', borderRadius:12, padding:14, background:'#fff',
                display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, cursor: 'pointer',
            }}
        >
            <div>
                <div style={{ fontWeight:600 }}>{term.title}</div>
                <div style={{ color:'#6b7280', fontSize:14 }}>
                    {term.group_name} • {fmtDT(term.exam_datetime)} • {term.exam_duration} min
                    {term.proctoring ? ' • proctoring' : ''}
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#111827' }}>
                <span style={{ fontSize: 14, fontWeight: 600 }}>{label}</span>
                <span aria-hidden="true" style={{ fontSize: 20, lineHeight: 1 }}>➜</span>
            </div>
        </div>
    );
}

function EmptyState() {
    return (
        <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:20, color:'#6b7280' }}>
            Brak nadchodzących terminów.
        </div>
    );
}
